<div *ngIf="formGroup" class="wrapper">
  <div class="header-form">
    <div>
      <ssg-select
        name="BranchId"
        [group]="formGroup"
        [dataList]="BranchLookUp"
        [label]="'ClientApp.FrontOffice.Inv.DailyWarehouse.Branch' | translate"
        textFieldName="Title"
        valueFieldName="Id"
        userClass="select-sm">
      </ssg-select>
    </div>
    <div>
      <date-picker
        id="VoucherDate"
        name="VoucherDate"
        [label]="'ClientApp.FrontOffice.Inv.DailyWarehouse.Date' | translate"
        [group]="formGroup"
        userClass="select-sm"
        required="false"
        textType="date"
        disabled="false">
      </date-picker>
    </div>
    <div>
      <ssg-button
        class="load-data"
        (click)="loadItems()"
        [tooltip]="'ClientApp.FrontOffice.Inv.DailyWarehouse.Date' | translate"
        icon="icon-cloud_download-F"
        [label]="'ClientApp.FrontOffice.Inv.DailyWarehouse.UploadInformation' | translate">
      </ssg-button>
    </div>
  </div>
  <div class="grid-wrapper">
    <kgrid
      *ngIf="itemColumns.length"
      [notLoadData]="true"
      [noAutoFitColumns]="true"
      [areaName]="areaName"
      [label]="label"
      [dataList]="dataList"
      [columns]="itemColumns"
      reportName="InvDailyWarehouse"
      pathPreFix="SALE"
      [isEdit]="false"
      [isDelete]="false"
      [isAdd]="false"
      [isModal]="false"
      [hasBracketForNegativeValues]="false"
      [filtering]="true"
      [paging]="true">
    </kgrid>
  </div>
</div>
